import request from '@/utils/request'

/**
 * 审批记录管理
 * @param {*} data
 * @returns
 */
export const getApprovalPage = (data) => {
  return request({
    method: 'GET',
    url: '/sys/v1/approval/findApprovalPage',
    params: data
  })
}

/**
 * 根据审批事件类型查询审批流程信息
 * @param {*} data
 * @returns
 */
export const getApprovalProcess = (data) => {
  return request({
    method: 'GET',
    url: '/sys/v1/approval/findApprovalProcess',
    params: data
  })
}

/**
 * 修改加密狗审批进度信息
 * @param {*} data
 * @returns
 */
export const updateDongleApproval = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/approval/updateDongleApproval',
    data
  })
}

/**
 * 修改应用审批进度信息
 * @param {*} data
 * @returns
 */
export const updateApplicationApproval = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/approval/updateAuthPlatformApproval',
    data
  })
}

/**
 * 查询平台小程序应用审批记录分页
 * @returns
 */
export const findAuthPlatformApprovalPage = (data) => {
  return request({
    url: '/sys/v1/approval/findAuthPlatformApprovalPage',
    params: data
  })
}

/**
 * 查询his加密狗审批记录分页
 * @returns
 */
export const findDongleApprovalPage = (data) => {
  return request({
    url: '/sys/v1/approval/findDongleApprovalPage',
    params: data
  })
}

/**
 * 修改授权平台应用审批进度信息（拒绝）
 * @returns
 */
export const rejectAuthPlatformApproval = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/approval/rejectAuthPlatformApproval',
    data
  })
}

/**
 * 修改加密狗审批进度信息(拒绝)
 * @returns
 */
export const rejectDongleApproval = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/approval/rejectDongleApproval',
    data
  })
}

/**
 * 根据id查询审批详情
 * @param {*} id
 * @returns
 */
export const getApprovalInfoById = (id) => {
  return request({
    url: `/sys/v1/approval/${id}`
  })
}
